import type { ReactNode } from "react";
import { Minus, Plus } from "@/components/icons";
import { Button, cn, Input } from "@/components/kit";

/** 16px text avoids iOS zoom; 48px hits a thumb-sized target. */
export const touchControlClass = "h-12 text-base";

export function TouchField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-muted-foreground text-xs">{label}</span>
      {children}
    </div>
  );
}

export function QtyStepper({
  value,
  onChange,
  min = 1,
}: {
  value: number;
  onChange: (value: number) => void;
  min?: number;
}) {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="size-12 shrink-0"
        aria-label="ຫຼຸດຈຳນວນ"
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        <Minus />
      </Button>
      <Input
        className={cn(touchControlClass, "text-center tabular-nums")}
        inputMode="numeric"
        aria-label="ຈຳນວນ"
        value={value}
        onChange={(event) => {
          const next = Number(event.target.value);
          onChange(Number.isFinite(next) ? Math.max(min, next) : min);
        }}
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="size-12 shrink-0"
        aria-label="ເພີ່ມຈຳນວນ"
        onClick={() => onChange(value + 1)}
      >
        <Plus />
      </Button>
    </div>
  );
}
